<div *ngIf="isSidePanelOpen" id="invisiblePanel" (click)="toggleSidePanel()"></div>
<div class="side-panel" [class.open]="isSidePanelOpen" [class.animated]="animated">
  <div class="side-panel-header">
    <button class="close-btn" (click)="toggleSidePanel()" aria-label="Close SidePanel" id="closeXButton">
      <i class="fa-solid fa-xmark"></i>
    </button>
    <div class="side-panel-title">
      <h2 *ngIf="sidePanelTitle">{{ sidePanelTitle }}</h2>
      <h3 *ngIf="sidePanelSubTitle">{{ sidePanelSubTitle }}</h3>
    </div>
  </div>

  <div class="side-panel-content">
    <ng-content></ng-content>
  </div>

</div>
